import React, {useMemo} from "react"

import Gallery from "../../../Gallery";
import {useApartment} from "../ApartmentContext";

const ApartmentPhotos = () => {
    const {photos, createPhoto, movePhoto, deletePhoto} = useApartment();

    const galleryPhotos = useMemo(
        () => photos.map(p => ({id: p.id, src: p.imgSquare, alt: p.title, position: p.orderPosition})),
        [photos]
    );

    return <Gallery photos={galleryPhotos}
                    onCreatePhoto={createPhoto}
                    onPositionChange={movePhoto}
                    onDeletePhoto={deletePhoto}/>
}

export default ApartmentPhotos;